module.exports = __webpack_public_path__ + "static/media/dev_productivity.cc909b91.svg";